import { Input, InputProps } from '~/components';
import { cn } from '~/style';

export type FormInputProps<V extends string | number> = {
  value: V;
  label?: string;
  placeholder?: string;
  onChange: (value: V) => void;
  type?: InputProps['type'];
  min?: InputProps['min'];
  max?: InputProps['max'];
  step?: InputProps['step'];
  autoCapitalize?: InputProps['autoCapitalize'];
  autoCorrect?: InputProps['autoCorrect'];
  spellCheck?: InputProps['spellCheck'];
  disabled?: boolean;
  className?: string;
};

export const FormInput = <V extends string | number>({
  value,
  label,
  placeholder,
  onChange,
  type,
  min,
  max,
  step,
  autoCapitalize,
  autoCorrect,
  spellCheck,
  disabled,
  className,
}: FormInputProps<V>) => {
  return (
    <div className="space-y-4">
      {label && (
        <div
          className={cn({
            'text-muted-foreground opacity-50': disabled,
          })}
        >
          {label}
        </div>
      )}

      <Input
        className={className}
        value={value}
        placeholder={placeholder && placeholder}
        onChange={(event) => onChange(event.target.value as V)}
        type={type}
        min={min}
        max={max}
        step={step}
        autoCapitalize={autoCapitalize}
        autoCorrect={autoCorrect}
        spellCheck={spellCheck}
        disabled={disabled}
      />
    </div>
  );
};
